var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBulletDocument = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .5)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#02769D",
    strokeWidth: 2,
    fill: "#E7F3F9",
    cx: 25,
    cy: 25,
    r: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10h30v30H10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5 24.625v1.313c0 .309-.253.562-.563.562h-7.875a.564.564 0 0 1-.562-.563v-1.312c0-.31.253-.563.563-.563h7.875c.309 0 .562.254.562.563zM28.937 28h-7.875a.564.564 0 0 0-.562.563v1.312c0 .31.253.563.563.563h7.875c.309 0 .562-.254.562-.563v-1.313a.564.564 0 0 0-.563-.562zM34 19.183V34.75A2.25 2.25 0 0 1 31.75 37h-13.5A2.25 2.25 0 0 1 16 34.75v-19.5A2.25 2.25 0 0 1 18.25 13h9.567c.596 0 1.167.24 1.59.66l3.932 3.934c.422.417.661.993.661 1.589zm-6-3.75V19h3.567L28 15.433zm3.75 19.317v-13.5h-4.875a1.122 1.122 0 0 1-1.125-1.125V15.25h-7.5v19.5h13.5z",
    fill: "#02769D",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBulletDocument);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bullet-document.1332d00ea792bc96cd71d035e743d625.svg";